import * as React from 'react'

import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg'

import { IconProps } from '../icons'

const ErrorFilled = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <G clipPath="url(#a)">
      <Path
        d="M12 2.4c-5.3 0-9.6 4.3-9.6 9.6s4.3 9.6 9.6 9.6 9.6-4.3 9.6-9.6-4.3-9.6-9.6-9.6Zm.93 13.3c-.22.22-.49.33-.81.33-.32 0-.61-.11-.82-.33-.22-.22-.33-.49-.33-.82 0-.33.11-.6.33-.82.22-.22.49-.33.82-.33.33 0 .6.11.81.33.22.22.33.49.33.82 0 .33-.11.6-.33.82Zm.44-6.82-.63 3.68c-.02.21-.09.36-.21.47a.59.59 0 0 1-.42.17.59.59 0 0 1-.42-.17.829.829 0 0 1-.22-.47l-.62-3.69s-.01-.11-.01-.19c0-.36.12-.63.36-.84.24-.2.54-.3.91-.3s.68.1.91.31c.24.21.36.49.36.84 0 .08 0 .14-.01.19Z"
        fill={color}
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default ErrorFilled
